module.exports = __webpack_public_path__ + "static/media/siri06.120b9997.jpg";